import ActivitiesIcon from '@material-ui/icons/DirectionsBike';
import ActivitiesList from './activitiesList';
import ActivitiesShow from './activitiesShow';

export default {
  list: ActivitiesList,
  show: ActivitiesShow,
  icon: ActivitiesIcon,
};
